import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-po-finish-prod-works',
  templateUrl: './po-finish-prod-works.component.html',
  styleUrls: ['./po-finish-prod-works.component.css']
})
export class PoFinishProdWorksComponent implements OnInit {
    p2PoFinishProdKeyno;

    public itemsListProductWorks: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.p2PoFinishProdKeyno = this.stateService.getStateParams()['p2_pofinishprod_keyno'];
    }

    private async loadProductWorks() {
        if (!!this.p2PoFinishProdKeyno) {
            this.itemsListProductWorks = await this.datatask.Post(263, { p2_pofinishprod_keyno: this.p2PoFinishProdKeyno });
        }
    }

    private async init() {
        this.loadProductWorks();
    }

    ngOnInit() {
        this.init();
    }
}
